module.exports = __webpack_public_path__ + "static/media/done.27ea57e5.svg";